import isPromise from 'is-promise';

import { clearAuth } from 'auth/actions';
import { addInlineMessage } from 'messages/actions';

const promiseRejectedMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (isPromise(action.payload) && action.meta && action.meta.needAuth === true) {
      return next(action).catch((err) => {
        /**
         * Dispatch clear auth and expired session message if response status is 401
         */
        if (err && err.code && err.code === 401) {
          dispatch(clearAuth());
          dispatch(addInlineMessage('error.session_expired', 'danger'));
        }

        if (err && err.code && err.code === 455) {
          dispatch(clearAuth());
          dispatch(addInlineMessage('error.session_terminated', 'danger'));
        }
        return Promise.reject(err);
      });
    }
    return next(action);
  };

export default promiseRejectedMiddleware;



// WEBPACK FOOTER //
// src/store/promiseRejectedMiddleware.js